/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useLayoutEffect, useState } from "react";
import { db } from "~/db/db";
import { lastCreatedAt } from "~services/utils/helpers";
import { useGetInfoTaticas } from "~pages/RouteOptimizationV2/hooks/useRoteirizacao";
import { useLiveQuery } from "dexie-react-hooks";

const useInfoTatica = ({ clienteId }) => {
  const [infosTatica, setInfosTatica] = useState([]);
  const [loading, setLoading] = useState(false);
  const [lastCreatedAtDate, setLastCreatedAtDate] = useState("");
  const [enabled, setEnabled] = useState(false);

  const infoTaticasRequest = useGetInfoTaticas(enabled, clienteId);

  useEffect(() => {
    if (infoTaticasRequest.isSuccess && infoTaticasRequest.data?.data) {
      db.infosTatica.where("clienteId").equals(Number.parseInt(clienteId)).delete();
      for (const insert of infoTaticasRequest.data?.data || []) {
        db.infosTatica.bulkAdd(insert);
      }
    }
  }, [infoTaticasRequest.data]);

  useLayoutEffect(() => {
    setEnabled(true);
  }, []);

  useLiveQuery(() => {
    const fetchInfosTatica = async () => {
      setLoading(true);
      const infos = [];
      setInfosTatica([]);
      await db.infosTatica
        .where("clienteId")
        .equals(Number.parseInt(clienteId))
        .each((infosTaticaItem) => {
          infos.push(infosTaticaItem);
        });
      setInfosTatica(infos);

      setLastCreatedAtDate(lastCreatedAt(infos));

      setLoading(false);
    };

    fetchInfosTatica();
  }, [clienteId]);

  const blocosInfoTatica = (infosTatica, bloco) => {
    if (!infosTatica || !bloco) return [];

    // Filtra os blocos e processa sub-blocos diretamente
    const blocosFiltrados = infosTatica.filter((item) => item?.bloco === bloco);
    return processarSubBlocos(blocosFiltrados, bloco);
  };

  const processarSubBlocos = (blocos, bloco) => {
    const subBlocosMap = new Map();

    for (const item of blocos) {
      const { subBloco } = item;

      if (!subBloco) continue;

      if (!subBlocosMap.has(subBloco)) {
        subBlocosMap.set(subBloco, {
          subBloco,
          datas: [],
          dados: [],
        });
      }

      const subBlocoAtual = subBlocosMap.get(subBloco);

      // Adiciona dados formatados e agrupados para "Gráfico"
      if (subBloco === "Gráfico") {
        subBlocoAtual.datas = extrairDatas(subBlocoAtual.datas, item);
        subBlocoAtual.dados = agruparDadosGrafico(subBlocoAtual.dados, item);
      } else {
        subBlocoAtual.dados.push(item);
      }
    }

    // Retorna sub-blocos diretamente ou como um array, dependendo do tipo de bloco
    return bloco === "VLOZ" ? Object.fromEntries(subBlocosMap) : Array.from(subBlocosMap.values());
  };

  const agruparDadosGrafico = (dadosExistentes, item) => {
    const { indicador } = item;

    if (!indicador) return dadosExistentes;

    const indicadorMap = new Map(dadosExistentes.map((d) => [d.indicador, d]));

    if (!indicadorMap.has(indicador)) {
      indicadorMap.set(indicador, { indicador, dados: [] });
    }

    indicadorMap.get(indicador).dados.push(item);

    return Array.from(indicadorMap.values());
  };

  const extrairDatas = (datasExistentes, item) => {
    const { data } = item;

    if (!data) return datasExistentes;

    const dataFormatada = new Date(data).toLocaleString("pt-BR", {
      year: "2-digit",
      month: "2-digit",
    });

    const datasMap = new Map(datasExistentes.map((d) => [d, true]));

    if (!datasMap.has(dataFormatada)) {
      datasMap.set(dataFormatada, true);
    }

    return Array.from(datasMap.keys());
  };

  return {
    infosTatica,
    taticaLastCreatedAtDate: lastCreatedAtDate,
    blocosInfoTatica,
    loading,
  };
};

export default useInfoTatica;
